export enum IframeMessageType {
    Resize = "resize",
    RequestScriptsUrl = "request_scripts_url",
    ProvideScriptsUrl = "provide_scripts_url"
}

export type ResizeMessage = {
    type: IframeMessageType.Resize;
    height: number;
};

export type RequestScriptsUrlMessage = {
    type: IframeMessageType.RequestScriptsUrl;
};

export type ProvideScriptsUrlMessage = {
    type: IframeMessageType.ProvideScriptsUrl;
    scriptsUrl: string;
};

export type IframeMessage =
    | ResizeMessage
    | RequestScriptsUrlMessage
    | ProvideScriptsUrlMessage;
